import * as v from "valibot";
import { baseVals, defineValidation } from "../../common/validation.common";
import { DisbursementGatewayEnum, PaymentGatewayEnum } from "../../data/enums";

export namespace SettingsValidation {
    export const FinanceSettings = defineValidation(
        v.object({
            ppn: v.exactOptional(baseVals.intMin(0, "PPN")),
            pph23: v.exactOptional(baseVals.intMin(0, "PPH23")),
            bhp: v.exactOptional(baseVals.intMin(0, "BHP")),
            uso: v.exactOptional(baseVals.intMin(0, "USO")),
            kso: v.exactOptional(baseVals.intMin(0, "KSO")),
        }),
    );

    export const ProfileSettings = defineValidation(
        v.object({
            logo: v.exactOptional(baseVals.string()),
            name: v.exactOptional(baseVals.string()),
            brand: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            email: v.exactOptional(baseVals.email()),
            address: v.exactOptional(baseVals.string()),
            village: v.exactOptional(baseVals.string()),
            district: v.exactOptional(baseVals.string()),
            regency: v.exactOptional(baseVals.string()),
            province: v.exactOptional(baseVals.string()),
            zipCode: v.exactOptional(baseVals.string()),
        }),
    );

    export const WhatsAppSettings = defineValidation(
        v.object({
            daemon: v.exactOptional(v.boolean()),
            token: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.string()),
            image: v.exactOptional(baseVals.string()),
            templateReminder: v.exactOptional(baseVals.string()),
            invoiceGap: v.exactOptional(baseVals.intRange(5, 10, "Tambahan Hari Toleransi Pembayaran Tagihan")),
            invoiceThreshold: v.exactOptional(baseVals.intMin(0, "Batas Minimal Pembayaran")),
        }),
    );

    export const FirebaseSettings = defineValidation(
        v.object({
            serviceAccount: v.exactOptional(
                v.pipe(
                    baseVals.string(),
                    v.transform((s) => {
                        const parts = s.split(",");
                        const data = Buffer.from(parts[1], "base64");
                        return data.toString("utf8");
                    }),
                    v.parseJson(),
                    v.looseObject({
                        project_id: baseVals.string(),
                        private_key: baseVals.string(),
                        client_email: baseVals.string(),
                    }),
                    v.stringifyJson(),
                ),
            ),
        }),
    );

    export const XenditSettings = defineValidation(
        v.object({
            token: v.exactOptional(baseVals.string()),
            paymentVersion: v.optional(v.picklist(PaymentGatewayEnum.valuesXendit)),
            disbursementVersion: v.optional(v.picklist(DisbursementGatewayEnum.valuesXendit)),
        }),
    );

    export const XenditMethod = defineValidation(
        v.object({
            name: v.string(),
            active: v.boolean(),
        }),
    );

    export const MobileSettings = defineValidation(
        v.object({
            minVersion: v.exactOptional(v.number()),
            latestVersion: v.exactOptional(v.number()),
        }),
    );
}
